<template>
  <v-dialog
    v-model="newGeneralTicketDialog"
    width="800px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>New General Support Ticket</h2>
        <div class="btn-container">
          <v-button
            size="small"
            @click="newGeneralTicketDialog = false">Cancel</v-button>
          <v-button
            size="small"
            type="primary"
            @click="handlerCreate">Create</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="dialog-content flex">
          <div class="left">
            <div class="form-item">
              <!--              <span>Assignee</span>-->
              <el-form-item
                prop="assignee_id"
                label="Assignee">
                <v-select
                  v-model="formData.assignee_id"
                  :disabled="!!formData.assignee_id"
                  :list="globalOptions.assignee" />
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Customer</span>-->
              <el-form-item
                prop="customer_id"
                label="Customer">
                <el-select
                  v-if="!!form.customer_id"
                  v-model="customerName"
                  disabled
                  size="small"
                >
                  <el-option
                    :label="customerName"
                    :value="customerName"></el-option>
                </el-select>
                <v-select
                  v-else
                  v-model="formData.customer_id"
                  :clearable="true"
                  remote
                  nameGroup
                  :remoteMethod="remoteMethodUser"
                  labelKey="isrd_nm"
                  :list="customerOptionsUser"
                  @change="changeCustomer" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Policy</span>
              <!-- <v-autocomplete
                v-model="formData.policy_no"
                :disabled="!!form.policy_no"
                labelKey="pcy_no"
                valueKey="pcy_no"
                :list="customerPolicyList"
                @select="handlerSelectPolicy"/> -->
              <v-autocomplete
                v-model="formData.pcy_id"
                :disabled="!!form.pcy_id"
                labelKey="pcy_id"
                valueKey="pcy_id"
                :list="customerPolicyList"
                @select="handlerSelectPolicy"/>
            </div>
            <div class="form-item">
              <span>Quote</span>
              <v-autocomplete
                v-model="formData.quote_no"
                :disabled="!!form.quote_no"
                labelKey="quotation_number"
                valueKey="quotation_number"
                :list="customerQuoteList" />
            </div>
          </div>
          <div class="right">
            <div class="form-item">
              <!--              <span>Title</span>-->
              <el-form-item
                prop="subject"
                label="Title">
                <v-input v-model="formData.subject" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Message</span>
              <v-input
                v-model="formData.message"
                type="textarea"
                :rows="9" />
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {createGeneralTicket, getCustomerPolicy} from '@/api/ticket'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'NewGeneralTicket',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      newGeneralTicketDialog:false,
      customerPolicyList: [],
      customerQuoteList: [],
      formData: {
        assignee_id: '',
        customer_id: '',
        // policy_no: '',
        pcy_id: '',
        quote_no: '',
        subject: '',
        message: ''
      }
    }
  },
  computed:{
    ...mapState('common', ['customerOptionsPhone','customerOptionsUser','customerOptionsEmail']),
    customerName(){
      let {isrd_nm} = this.customer||{}
      return isrd_nm ? isrd_nm : ' '
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = Object.assign(this.formData, val)
      }
    },
    // 'formData.customer_id': {
    //   // immediate: true,
    //   handler(val) {
    //     if(val) {
    //       this.handlerChangeCustomer(val)
    //     }
    //   }
    // }
  },
  created() {
    let name = localStorage.getItem('cs_name')
    let arr = this.globalOptions.assignee||[]
    arr.some(item=>{
      if(item.name==name)
        this.formData.assignee_id = item.id
    })
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),

    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changeDialog() {
      if(this.formData.customer_id && this.customerPolicyList.length < 1) {
        this.handlerChangeCustomer(this.formData.customer_id)
      }
      this.newGeneralTicketDialog = !this.newGeneralTicketDialog
    },
    changeCustomer(id) {
      this.handlerChangeCustomer(id)
    },
    handlerChangeCustomer(id) {
      if(id) {
        this.network().getCustomerPolicy(id)
      }
    },
    handlerCreate() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().createGeneralTicket()
          this.setCustomerOptionNUll()
        }
      })

    },
    handlerSelectPolicy(item) {
      this.formData.quote_no = item.quotation_number
    },
    network() {
      return {
        createGeneralTicket: async () => {
          const { data } = await createGeneralTicket(this.formData)
          this.changeDialog()
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },
        getCustomerPolicy: async id => {
          const { data } = await getCustomerPolicy({
            customer_id: id
          })
          this.customerPolicyList = data.policy
          this.customerQuoteList = data.quote
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
